import {
  EVENT_ASSETS_FETCH_START,
  EVENT_ASSETS_FETCH_FAIL,
  EVENT_ASSETS_FETCH_SUCCESS,
} from '../constants/event.actionTypes'
import { fetchEventListings } from '../providers/listings'
import { getFiltersForApi } from '../utils/event.filters'

const eventAssetsActions = {
  fetchAssets: function (req, params) {
    const { filters, auctionDate, venues, ...fetchParams } = params
    const newFetchParams = {
      ...fetchParams,
      ...getFiltersForApi(filters),
    }

    if (auctionDate) {
      newFetchParams.act_dt_st_min = auctionDate
      newFetchParams.act_dt_st_max = auctionDate
    }

    if (venues && venues.length) {
      newFetchParams.venue_id = venues.join(',')
    }

    return {
      types: [
        EVENT_ASSETS_FETCH_START,
        EVENT_ASSETS_FETCH_SUCCESS,
        EVENT_ASSETS_FETCH_FAIL,
      ],
      promise: fetchEventListings(req, newFetchParams).then(seekResponse => ({
        ...seekResponse,
        offset: params.offset,
      })),
    }
  },
}

export default eventAssetsActions
